<template>
  <TsCardBranchV1
    data-testid="checkout-branch-selector"
    title="Set your branch for shipping"
    external-save
    @save="(selectedBranch) => handleSubmit(selectedBranch)"
  >
    <template
      #footer
      v-if="
        branchStore.nearestBranches.length &&
        !branchStore.isProcessingNearestBranchSearch
      "
    >
      <div class="flex justify-center border-t-2 pt-4 mb-4">
        <TsButton
          type="submit"
          :isLoading="props.isSaving"
          :disabled="!branchStore.currentBranchChoice || props.isSaving"
          :label='useTranslation( "Checkout-selectBranchForDelivery", "Selecteer filiaal voor bezorging")'
        />
      </div>
    </template>
  </TsCardBranchV1>
</template>

<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";
import {
  CustomerAddressType,
  type RawCustomerAddressItem,
} from "~/types/ecom/address.type";
import type { Branch } from "~/types/ecom/branch.type";
import type { Prettify } from "~/types/shared.type";

const publicRuntimeConfig = useRuntimeConfig().public;

const TsCardBranchV1 = defineAsyncComponent(
  () => import("~/components/organisms/TsCardBranchV1.vue")
);

type Props = {
  dataTestid: string;
  isSaving?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  isSaving: false,
});

function handleSubmit(data: Branch) {
  const branchAddress = {
    type: CustomerAddressType.DELIVERY,
    postcode: data.postcode,
    line_1: data.address[0],
    line_2: data.address[1],
    town: data.name,
    country_id: publicRuntimeConfig.appRegion === "BE" ? 9 : 8,
  };
  emit("submit", branchAddress);
}

const branchStore = useBranchStore();

const emit = defineEmits<{
  submit: [data: Prettify<RawCustomerAddressItem>];
}>();
</script>
